@if (!errorDeactivatingUser) {
	<div class="pop-up-dialog-v2">
		<h3 i18n="@@deactivateMobileUUID-deactivateMobileUUIDHeader">Deactivate mobile UUID</h3>
		<mat-divider></mat-divider>
		<mat-dialog-content class="main-text-container">
			<div i18n="@@deactivateMobileUUID-confirmationText">
				Deactivating this mobile UUID will disable its current access. Reactivation can be done by the user logging in
				from this account. Continue?
			</div>
			@if (loadingService.isLoading(getDeactivateMobileUUIDLoadingKey)) {
				<div class="loading-container">
					<mat-spinner diameter="30" class="loading-spinner"></mat-spinner>
				</div>
			}
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				(click)="onCloseClicked(false)"
				class="secondary-small-button"
				i18n="@@deactivateMobileUUID-deactivateUserDialogCancel"
				data-automation-id="deactivate-mobile-uuid-cancel-button"
				[disabled]="loadingService.isLoading(getDeactivateMobileUUIDLoadingKey)"
			>
				Cancel
			</button>
			<button
				(click)="onDeactivateClicked()"
				class="warning-small-button"
				i18n="@@deactivateMobileUUID-deactivateUserDialogDeactivate"
				data-automation-id="deactivate-mobile-uuid-confirm-button"
				[disabled]="loadingService.isLoading(getDeactivateMobileUUIDLoadingKey)"
			>
				Deactivate
			</button>
		</mat-dialog-actions>
	</div>
}

@if (errorDeactivatingUser) {
	<div class="pop-up-dialog-v2">
		<h3 i18n="@@deactivateMobileUUID-errorDeletingUserHeader">Error!</h3>
		<mat-divider></mat-divider>
		<mat-dialog-content>
			<div i18n="@@deactivateMobileUUID-unableToDeactivate">
				Unable to deactivate this mobile UUID at this time. Please try again.
			</div>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				(click)="onCloseClicked(false)"
				class="primary-small-button"
				i18n="@@deactivateMobileUUID-errorDeactivatingUserConfirm"
				data-automation-id="deactivate-mobile-uuid-ok-button"
			>
				Ok
			</button>
		</mat-dialog-actions>
	</div>
}
